import dominant from 'huey/dominant';
import get from './getImageData.js';

const calculateImageDominantColor = imagePath => new Promise((resolve, reject) => {
  get(imagePath, (err, img) => {
    if (err) {
      reject(new Error(`TDS: Could not get image data for '${imagePath}'.`));
    } else {
      const dominantColor = dominant(img.data, 90);
      if (dominantColor) {
        resolve(dominantColor);
      } else {
        reject(new Error(`TDS: Could not calculate dominant color of '${imagePath}'.`));
      }
    }
  });
});
var calculateImageDominantColor$1 = calculateImageDominantColor;

export { calculateImageDominantColor$1 as default };
